import React, { useContext, useEffect, useState } from "react";
import { Accordion, Card, Button, Badge } from "react-bootstrap";
import { RiArrowDropDownLine } from "react-icons/ri";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { twoDecimalPlaces } from "../../utils/utilFuctions";
import { Viewsalaryslipemployee } from "./Modal";

const Salaryslipemployee = () => {
    
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); 
  const [viewModalShow, setViewModalShow] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("January");

  const handleViewButtonClick = () => {
    setViewModalShow(true);
  };

  const handleCloseModal = () => {
    setViewModalShow(false);
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleMonthClick = async (month) => {
    setSelectedMonth(month);
    await getEmployeeSalarySlip(month,selectedYear);
  };

  const getEmployeeSalarySlip = async (month,year) => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: JSON.stringify({
          token:user.login_token,
          month: month,
          year: String(year),
        }),
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeSalarySlip`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0" && data.data.length > 0) {
        const employeeData = data.data[0];
        setEmployee({
          ...employeeData,
          current_month: month,
          current_year: String(year),
        });
      } else {
        setEmployee(null);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getEmployeeSalarySlip(selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  return (
    <>
     <Viewsalaryslipemployee
        show={viewModalShow}
        handleClose={handleCloseModal}
        employee={employee}
      />
     <div className="row  mt-4">
        <div className="col-md-8 col-4">
          <h4>Salary Slip</h4>
        </div>
        <div className="col-md-4 col-8 px-4 text-end">
          <select
            className="form-control"
            value={selectedYear}
            onChange={handleYearChange}
            style={{ width: "120px", display: "inline-block" }}
          >
            {Array.from({ length: 5 }, (_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <CustomAccordion
        months={months}
        selectedYear={selectedYear}
        employee={employee}
        handleMonthClick={handleMonthClick}
        handleViewButtonClick ={handleViewButtonClick}
      />
     
    </>
  );
};
const CustomAccordion = ({ months = [], selectedYear, employee, handleMonthClick,handleViewButtonClick }) => {
  
    const [openIndex, setOpenIndex] = useState(-1);
  
    const toggleIndex = (index, month) => {
      if (openIndex === index) {
        setOpenIndex(-1);
      } else {
        setOpenIndex(index);
        if (handleMonthClick) {
          // handleMonthClick(month);
        }
      }
    };
    const twoDecimalPlaces = (num) => {
      if (typeof num === "number") return num.toFixed(2);
      if (typeof num === "string") return parseFloat(num).toFixed(2);
      return "N/A";
    };
  
    return (
      <div className="custom-accordion" style={{ margin: "0 1rem" }}>
        {months.length === 0 && <div>No months data</div>}
        {months.map((month, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              className="accordion-item"
              style={{
                marginBottom: "0.5rem",
                borderRadius: ".2rem",
                border: "1px solid rgb(170, 215, 189)",
                overflow: "hidden",
                boxShadow: "0 1px 3px rgb(0 0 0 / 0.1)",
              }}
            >
              {/* Header */}
              <div
                // onClick={() => toggleIndex(index, month)}
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "rgb(236, 246, 240)",
                  padding: "0.5rem 1rem",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <div>{month} {selectedYear}</div>
                <RiArrowDropDownLine
                  style={{
                    fontSize: "1.5rem",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
  
              {/* Content */}
              {isOpen && (
                <div
                  className="accordion-content"
                  style={{
                    background: "#FEFAF6",
                    borderTop: "1px solid rgb(170, 215, 189)",
                    padding: "1rem",
                  }}
                >
                  <div
  style={{
    textAlign: "center",
    padding: "2rem",
    fontSize: "1rem",
    color: "#888",
    fontWeight: "500",
  }}
>
  🚧 We are working on it. Salary slip will be available soon.
</div>
                   {/* {employee ? (
                    <table
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        tableLayout: "fixed",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          background: "#fff",
                        }}
                      >
                        <tr>
                          {[
                            "Emp Code",
                            "Name",
                            "Month",
                            "Gross Salary",
                            "Net Pay",
                            "Status",
                            "Salary Slip",
                          ].map((header) => (
                            <th
                              key={header}
                              style={{
                                borderBottom: "1px solid #f2f4f2",
                                color: "#000",
                                padding: "8px",
                                textAlign: "left",
                                background: "#fff",
                              }}
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ border: "none", cursor: "pointer" }}>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            {employee.emp_code || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            {employee.name || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            {[employee.current_month, employee.current_year].filter(Boolean).join(" ") || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            {twoDecimalPlaces(employee.totalSalarywithpf || 0)}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            {twoDecimalPlaces(employee.totalSalary || 0)}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            <span
                              style={{
                                backgroundColor:
                                  employee.status === "Y"
                                    ? "rgba(43, 193, 85, 0.1)"
                                    : "rgba(255, 0, 0, 0.1)",
                                color:
                                  employee.status === "Y" ? "#2bc155" : "#ff0000",
                                border:
                                  employee.status === "Y"
                                    ? "1px solid #2bc155"
                                    : "1px solid #ff0000",
                                borderRadius: ".3rem",
                                fontSize: "1rem",
                                display: "inline-block",
                                textAlign: "center",
                                padding: "0.1rem 0.5rem",
                              }}
                            >
                              {employee.status === "Y"
                                ? "Processed"
                                : "Unprocessed"}
                            </span>
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "none",
                              fontSize: ".9rem",
                            }}
                          >
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleViewButtonClick}
                            >
                              View salary slip
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <div>No data found for {month} month</div>
                  )}  */}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };
  
export default Salaryslipemployee;
